module.exports = {"id":"230483","name":"Jacson Zonta","rating":"74","photo":"./data/images/photos/0/230483.png","club":{"name":"Atlético-GO","logo":"./data/images/clubs/Atletico-GO.png"},"positions":["MOC","MD","MG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JacsonZonta0.json
// module id = 1871
// module chunks = 0